import { Alert, AlertIcon, Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, Text, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import DOMPurify from 'dompurify';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import { ViewTermsAndConditions } from '.';
import { convertToHTML } from 'draft-convert';
import { updateCompanyTermsAndConditions } from '../../store/actions';

export const EditTermsAndConditions = () => {

    const [isPublishing, setIsPublishing] = useState<boolean>(false);
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty(),);
    const [convertedContent, setConvertedContent] = useState<string | null>(null);

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { company } = useAppSelector(state => state.companyReducer);
    const { company_id, website } = company ?? {};
    const { terms_and_conditions } = website ?? {};

    const dispatch: AppDispatch = useAppDispatch();

    const handlePublish = () => {
        setIsPublishing(true);
        dispatch(updateCompanyTermsAndConditions({ company_id, terms_and_conditions: convertedContent }))
            .then(() => setIsPublishing(false))
            .catch(() => setIsPublishing(false));
    };

    const createMarkup = (html: string | null | any) => {
        return {
            __html: DOMPurify.sanitize(html)
        };
    };

    useEffect(() => {
        const html = convertToHTML(editorState.getCurrentContent());
        setConvertedContent(html);
    }, [editorState]);

    return (
        <>
            <Stack bg={'#f5f5f5'} p={4} borderRadius={'md'}>
                <Alert status='info' borderRadius={6}>
                    <AlertIcon />
                    Make sure you publish your draft!
                </Alert>
                <Editor
                    initialContentState={terms_and_conditions}
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                />
                <HStack pt={3} justifyContent={'flex-end'}>
                    <Button
                        maxW={'300px'}
                        variant={'outline'}
                        alignSelf={'flex-end'}
                        colorScheme={'yellow'}
                        onClick={onOpen}
                    >Preview</Button>
                    <Button
                        maxW={'300px'}
                        alignSelf={'flex-end'}
                        colorScheme={'yellow'}
                        onClick={handlePublish}
                        isLoading={isPublishing}
                        isDisabled={isPublishing}
                        loadingText={'Publishing...'}
                    >Publish</Button>
                </HStack>
            </Stack>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Preview terms and conditions.</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack borderWidth={1} borderRadius={6} mb={4}>
                            <div
                                style={{
                                    padding: '1rem',
                                }}
                                dangerouslySetInnerHTML={createMarkup(convertedContent)}>
                            </div>
                        </Stack>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export const TermsAndConditionsEditor = () => {

    const [state, setState] = useState<'editor' | 'view'>('view');

    const { company } = useAppSelector(state => state.companyReducer);
    const { website, name } = company ?? {};
    const { terms_and_conditions } = website ?? {};

    const handleChangeState = () => {
        if (state === 'editor') {
            setState('view');
        } else if (state === 'view') {
            setState('editor');
        }
    };

    useEffect(() => {

    }, []);

    return (
        <>
            <HStack justifyContent={'space-between'} bg={'#FFFFFF'} p={4} borderRadius={6} mb={3}>
                <Text textTransform={'capitalize'} fontSize={'lg'} fontWeight={'medium'}>{name} terms and conditions.</Text>
                <Button colorScheme={'green'} size={'sm'} onClick={handleChangeState}>{state === 'editor' && 'View Current T&C'}{state === 'view' && 'Edit T&C'}</Button>
            </HStack>
            {
                state === 'view' && <ViewTermsAndConditions terms_and_conditions={terms_and_conditions} />
            }
            {
                state === 'editor' && <EditTermsAndConditions />
            }
        </>
    );

};